"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M0 12c0 .099.03.198.089.284.189.275 4.73 6.716 11.91 6.716 1.763 0 3.47-.524 5.016-1.279l3.131 3.132a.5.5 0 0 0 .707-.707l-2.913-2.913c3.325-1.887 5.713-4.642 5.932-4.9l.01-.01a.508.508 0 0 0 .049-.07l.002-.004a.502.502 0 0 0-.05-.572C23.65 11.404 18.16 5 12 5c-1.755 0-3.456.52-4.996 1.27l-3.15-3.124a.498.498 0 0 0-.708 0 .5.5 0 0 0 0 .707L6.06 6.767C3.314 8.325 1.207 10.475.432 11.322l-.314.355A.5.5 0 0 0 0 12Zm12-3c-.632 0-1.235.194-1.738.554l-1.09.325-2.37-2.37c-.558.307-1.093.642-1.597.989l9.149 9.148-.03.03c.662-.178 1.31-.423 1.934-.711L9.172 9.879s1.086-.322 1.09-.325l4.184 4.184A3.004 3.004 0 0 0 12 9Zm-7.616.091 8.82 8.82c-.399.058-.8.089-1.204.089-.473 0-.934-.031-1.383-.09l-7.654-7.654c.423-.373.9-.77 1.421-1.165Zm-2.159 1.842 6.589 6.588c-3.755-1.134-6.425-3.98-7.446-5.218l-.222-.276c.228-.248.596-.634 1.08-1.094ZM12.117 6c4.477.066 8.732 3.956 10.333 5.6l.38.399c-.756.816-2.912 2.998-5.635 4.487l-2.034-2.034c.545-.698.84-1.553.84-2.453 0-2.206-1.794-4-4-4-.9 0-1.755.295-2.453.84L7.742 7.035C9.082 6.416 10.53 6 12 6h.116Z",
    clipRule: "evenodd"
  })]
});